<template>
  <page-section :title="$t('Integrations_Overview_Information')">
    <form-section>
      {{ $t('Integrations_Gcs_Text_Information') }}
    </form-section>
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import FormSection from '@/common/components/form/FormSection'

export default {
  name: 'GcsOverview',

  components: {
    FormSection,
    PageSection
  },

  props: {
    model: {
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/gcs/GcsOverview.vue